/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Option/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Multiple from './Multiple/index'
import React from 'react'
import Single from './Single/index'



/** @type {import('Simple/types.js').View} */
export default function Option({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/ScheduleOptions/Content/SlotSelect/Content/Content/Content/Options/Option"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Single'
let groupValueData = fromData.useDataFormat({ viewPath,
context: 'group',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: groupValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Single'}>
<Single
  viewPath={`${viewPath}/Single`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Multiple'}>
<Multiple
  viewPath={`${viewPath}/Multiple`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}